import { render, staticRenderFns } from "./ReturnedPurchase.vue?vue&type=template&id=65562a03&scoped=true&"
import script from "./ReturnedPurchase.vue?vue&type=script&lang=js&"
export * from "./ReturnedPurchase.vue?vue&type=script&lang=js&"
import style0 from "./ReturnedPurchase.vue?vue&type=style&index=0&id=65562a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65562a03",
  null
  
)

export default component.exports